import React, {FC} from 'react';
import PostCard from 'components/blog/PostCard';
import {useLatest} from 'components/blog/useBlogs/useLatest';

import * as styles from './styles.module.scss';

type LatestBlogItemsProps = {
    title: string;
}

const LatestBlogItems: FC<LatestBlogItemsProps> = ({title}) => {
	const posts = useLatest();
	return (
		<div className={styles.latestBlogItems}>
			<h4 className={styles.title}>{title}</h4>
			<div className={styles.content}>
				{posts.map((post, index) => (
					<PostCard {...post} key={index} />
				))}
			</div>
		</div>
	);
};

export default LatestBlogItems;
